<template>
  <validation-observer
    v-slot="{ errors }"
    ref="lokasiObserver"
    class="mb-[16px] block"
  >
    <ReusableInput
      v-model="form.location_link"
      name="Lokasi"
      label="Lokasi"
      placeholder="Masukan link Google Maps"
      rules="required|google-maps-url"
      :required="true"
      :disabled="enableEditInput"
      container-class="!mb-[8px]"
    >
      <template #error>
        <div />
      </template>
    </ReusableInput>
    <ReusableInput
      v-model="form.location_name"
      name="Nama Kota"
      label=""
      placeholder="Masukkan nama kota"
      rules="required"
      :disabled="enableEditInput"
      container-class="!mb-[8px]"
    >
      <template #error>
        <div />
      </template>
    </ReusableInput>
    <div class="flex items-center justify-center mb-[8px] gap-[8px]">
      <div class="w-full grow">
        <ReusableInput
          v-model="form.latitude"
          name="Latitude"
          label=""
          placeholder="Masukkan latitude"
          rules="required"
          :disabled="enableEditInput"
          container-class="!mb-[2px]"
        >
          <template #error>
            <div />
          </template>
        </ReusableInput>
      </div>
      <div class="w-full grow">
        <ReusableInput
          v-model="form.longitude"
          name="Longitude"
          label=""
          placeholder="Masukkan longitude"
          rules="required"
          :disabled="enableEditInput"
          container-class="!mb-[2px]"
        >
          <template #error>
            <div />
          </template>
        </ReusableInput>
      </div>
    </div>
    <small
      v-if="printErrors(errors).show"
      class="text-danger d-block"
    >
      {{ printErrors(errors).message }}
    </small>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import ReusableInput from './Input.vue'

/**
 * CIGLokasi
 * @description CIGLokasi is a component that displays the location of the warehouse
 * @param {Object} form - The form data
 * @param {Boolean} enableEditInput - The enable edit input
 * @returns {Object} CIGLokasi
 */
export default {
  name: 'CIGLokasi',
  components: {
    ValidationObserver,
    ReusableInput,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    enableEditInput: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    /**
     * Print the errors
     * @param {Object} errors - The errors
     * @returns {Object} The errors
     */
    printErrors(errors) {
      const requiredFields = ['Lokasi', 'Nama Kota', 'Latitude', 'Longitude']

      const activeErrorFields = requiredFields.filter(field => errors[field] && errors[field].length > 0)

      if (activeErrorFields.length === 0) {
        return { show: false, message: '' }
      }

      if (activeErrorFields.length > 1) {
        const fields = activeErrorFields.map(field => field.toLowerCase())
        const lastField = fields.pop()
        const errorFields = fields.length > 0
          ? `${fields.join(', ')} dan ${lastField}`
          : lastField
        return {
          show: true,
          message: `Data ${errorFields} wajib diisi lengkap`,
        }
      }

      const singleField = activeErrorFields[0]
      return {
        show: true,
        message: errors[singleField][0],
      }
    },
  },
}
</script>
